import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      // pointer-events-auto keeps toasts clickable even when a Radix modal
      // sets body `pointer-events: none` on the document body.
      className="toaster group pointer-events-auto"
      closeButton={false}
      position="bottom-left"
    />
  );
}
